var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-section',{attrs:{"icon":"backpack","title":"Bagaglio a mano","description":_vm.flight_offer.source === 'GDS'
      ? `Nei voli di linea il bagaglio a mano comprende un trolley. Il peso ammesso
    può variare in base alla compagnia aerea. Controlla le condizioni e le
    franchigie sul sito della compagnia.`
      : `Nei voli low cost il bagaglio a mano include una borsa di piccole
    dimensioni da posizionare sotto il sedile. Verifica le specifiche sul sito
    della compagnia aerea.`}})
}
var staticRenderFns = []

export { render, staticRenderFns }